"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAbsoluteUrl = toAbsoluteUrl;
function toAbsoluteUrl(url) {
    if (url === null || url === undefined) {
        return undefined;
    }
    if (url.startsWith('//')) {
        return `https:${url}`;
    }
    return /^www\./i.test(url) ? `https://${url}` : url;
}
//# sourceMappingURL=protocol-relative-url.js.map